import { searchCodes } from './SearchCodes';
// 技术领域
const codes = searchCodes
  .find((_) => _.code == '02')
  .childs.map((_) => {
    return {
      data: _.code,
      name: _.name,
    };
  });
export const techs = [
  { name: '全部', data: '' },
  { name: '生物与新医药', data: '1' },
  { name: '新材料', data: '2' },
  { name: '电子信息', data: '3' },
  { name: '先进制造与自动化', data: '4' },
  { name: '资源与环境', data: '5' },
  { name: '新能源与节能', data: '6' },
  { name: '航空航天', data: '7' },
  { name: '高新技术服务', data: '8' },
  { name: '其他', data: '9' },
];
// 一级地区
/**
 * 320000 江苏省
 * 320400 常州市
 */
export const firstArea = [
  {
    name: '常州市',
    data: '320400',
  },
  {
    name: '江苏省',
    data: '320000',
  },
  {
    name: '全国',
    data: '',
  },
];
// 常州地区
export const areas = [
  {
    name: '全部',
    data: '',
  },
  {
    name: '溧阳市',
    data: '320481',
  },
  {
    name: '金坛区',
    data: '320413',
  },
  {
    name: '武进区',
    data: '320412',
  },
  {
    name: '新北区',
    data: '320411',
  },
  {
    name: '钟楼区',
    data: '320404',
  },
  {
    name: '天宁区',
    data: '320402',
  },
  {
    name: '科教城',
    data: '320403',
  },
  {
    name: '常州经开区',
    data: '320472',
  },
];

export const jsAreas = [
  {
    name: '全部',
    data: '',
  },
  {
    name: '南京市',
    data: '320100',
  },
  {
    name: '无锡市',
    data: '320200',
  },
  {
    name: '徐州市',
    data: '320300',
  },
  {
    name: '苏州市',
    data: '320500',
  },
  {
    name: '南通市',
    data: '320600',
  },
  {
    name: '连云港市',
    data: '320700',
  },
  {
    name: '淮安市',
    data: '320800',
  },
  {
    name: '盐城市',
    data: '320900',
  },
  {
    name: '扬州市',
    data: '321000',
  },
  {
    name: '镇江市',
    data: '321100',
  },
  {
    name: '泰州市',
    data: '321200',
  },
  {
    name: '宿迁市',
    data: '321300',
  },
];

export const czHomePath = '/branch/changzhou';

// 需求状态
export const status = [];
